/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Checkbox } from '@fnacdarty/back-office-ui';

const StyledCheckList = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
`;

const StyledCheckRow = styled.div`
	width: 100%;
	height: 50px;
	padding: 15px;
	border: 1px solid
		${({ $checked, theme }) =>
			$checked ? theme.colors.primary : theme.colors.muted};
	background-color: ${({ $checked, theme }) =>
		$checked ? theme.colors.primary : theme.colors.background};
	transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
	border-radius: 10px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 10px;
	&:last-child {
		margin-bottom: 0;
	}
	& > span {
		margin-left: 4px;
		color: ${({ theme, $checked }) =>
			$checked ? '#ffffff' : theme.colors.text};
		flex-grow: 1;
	}
`;
function groupArray(arr, size) {
	const groupedList = [];
	for (let i = 0; i < arr.length; i += size) {
		groupedList.push(arr.slice(i, i + size));
	}
	return groupedList;
}

const CheckList = ({
	list,
	updateList,
	identifier = 'value',
	label = 'label',
	isVersionPC,
	...props
}) => {
	const columns = isVersionPC() ? 3 : 2;
	const groupedList = groupArray(list, columns);

	const handleCheck = (value) => {
		const newList = list.map((item) => {
			if (item[identifier] === value) {
				return { ...item, checked: !item.checked };
			}
			return item;
		});
		updateList(newList);
	};

	return (
		<StyledCheckList {...props}>
			{' '}
			{groupedList.map((row, rowIndex) => (
				<div
					key={rowIndex}
					style={{
						display: 'flex',
						justifyContent: 'center',
						marginBottom: '5px',
					}}
				>
					{' '}
					{row.map((item, index) => (
						<StyledCheckRow
							key={index}
							$checked={item.checked}
							onClick={() => {
								handleCheck(item[identifier]);
							}}
							style={{
								minWidth: '125px',
								marginRight: rowIndex === 2 ? 0 : '2px',
								marginLeft: rowIndex === 2 ? 3 : '2px',
							}}
						>
							<Checkbox checked={item.checked} />
							<span>{item[label]}</span>
						</StyledCheckRow>
					))}
				</div>
			))}
		</StyledCheckList>
	);
};

CheckList.propTypes = {
	isVersionPC: PropTypes.func,
};
export default CheckList;
